import{post}from"./base_upData";
//添加图片
export function postDocumentImg(File){
    return post('/api/admin/common/update',File,{headers:{'Content-Type':'multipart/form-data'}})
}
